import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { makeQuickFetchRequest } from 'marketing-platform-lib/utils/quickFetch';
export const FETCH_CRM_OBJECT_INBOUND_DB_FIELD_NAME = 'marketingPlatformLib_fetchCrmObjectInboundDb';
export const FETCH_CRM_OBJECT_INBOUND_DB_QUERY = registerQuery({
  fieldName: FETCH_CRM_OBJECT_INBOUND_DB_FIELD_NAME,
  args: ['objectId', 'objectTypeId', 'quickFetchName'],
  fetcher({
    objectId,
    objectTypeId,
    quickFetchName
  }) {
    const crmSearchRequest = () => http.get(`/inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}`, {
      query: {
        includeAllValues: true
      }
    });
    return makeQuickFetchRequest({
      makeRequestFn: crmSearchRequest,
      requestName: quickFetchName
    });
  }
});
export default function useFetchObjectFromInboundDb({
  objectId,
  objectTypeId,
  quickFetchName
}, options) {
  const _useQuery = useQuery(FETCH_CRM_OBJECT_INBOUND_DB_QUERY, Object.assign({
      variables: {
        objectId,
        objectTypeId,
        quickFetchName
      }
    }, options || {})),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const isValidCrmObject = Boolean(data && data[FETCH_CRM_OBJECT_INBOUND_DB_FIELD_NAME] && !!data[FETCH_CRM_OBJECT_INBOUND_DB_FIELD_NAME].objectId);
  return Object.assign({
    data: isValidCrmObject ? data[FETCH_CRM_OBJECT_INBOUND_DB_FIELD_NAME] : undefined
  }, rest);
}